import React, { FC, useEffect } from 'react';
import { Box, Button, Grid } from '@material-ui/core';
import moment from 'moment';

import { StandFormInstance } from './types';
import { useEntityState } from '../../hooks/use-entity-state';
import SelectField from '../common/select-field';
import FieldView from '../common/field-view';
import { USER_DATE_FORMAT } from '../../utils/constants';
import { useGuide } from '../../hooks/use-guide';

interface StandFormProps {
  instance: Partial<StandFormInstance>;
  submitText?: string;
  onSubmit: (instance: Partial<StandFormInstance>) => void;
  onCancel: () => void;
}

const StandForm: FC<StandFormProps> = (props) => {
  const { instance, submitText, onSubmit, onCancel } = props;

  const [stand, onChange, setInstance] =
    useEntityState<StandFormInstance>(instance);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => setInstance(instance), [instance]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={12}>
        <FieldView title="Торговая точка" value={stand?.outlet.name} />
        <FieldView
          title="Дата установки"
          value={
            stand?.update_dt
              ? moment(stand?.mount_date).format(USER_DATE_FORMAT)
              : 'не указано'
          }
        />
        <FieldView
          title="Дата последнего посещения"
          value={
            stand?.update_dt
              ? moment(stand?.update_dt).format(USER_DATE_FORMAT)
              : 'не указано'
          }
        />
      </Grid>
      {/*<Grid item xs={12} sm={12}>*/}
      {/*  <SelectField*/}
      {/*    id="document_type"*/}
      {/*    name="document_type"*/}
      {/*    label="Тип"*/}
      {/*    value={stand.type || undefined}*/}
      {/*    options={stand.type ? [stand.type] : []}*/}
      {/*    onFetchOptions={useGuide('equipment_model_stand')}*/}
      {/*    onChange={onChange('type')}*/}
      {/*  >*/}
      {/*  </SelectField>*/}
      {/*</Grid>*/}
      {/*<Grid item xs={12} sm={12}>*/}
      {/*  <SelectField*/}
      {/*    id="agreement_type_id"*/}
      {/*    name="document_type"*/}
      {/*    label="Тип"*/}
      {/*    value={stand.type || undefined}*/}
      {/*    options={stand.type ? [stand.type] : []}*/}
      {/*    onFetchOptions={useGuide('stand_brand' , equip.type?.id ? {equip_model_id: '' + equip.type.id} : undefined)}*/}
      {/*    onChange={onChange('type')}*/}
      {/*  >*/}
      {/*  </SelectField>*/}
      {/*</Grid>*/}
      <Grid item xs={12} sm={12}>
        <SelectField
          id="stand_model"
          name="stand_model"
          label="Модель"
          value={stand.model || undefined}
          options={stand.model ? [stand.model] : []}
          onFetchOptions={useGuide(
            'equipment_model/stand' /* , equip.type?.id && equip.brand?.id ? {equip_model_id: '' + equip.type.id, stand_brand_id: '' + equip.brand.id} : undefined*/
          )}
          onChange={onChange('model')}
        ></SelectField>
      </Grid>
      <Grid item xs={12}>
        <Box display="flex" justifyContent="space-between">
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={() => onSubmit({ ...stand })}
          >
            {submitText || 'Создать'}
          </Button>
          <Button
            variant="outlined"
            color="primary"
            size="large"
            onClick={onCancel}
          >
            Отмена
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
};

export default StandForm;
